export default "__VITE_ASSET__BHvESrHs__"